"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_MIME_TYPES = exports.UploadMimeType = void 0;
var UploadMimeType;
(function (UploadMimeType) {
    UploadMimeType["Text"] = "text";
    UploadMimeType["Image"] = "image";
    UploadMimeType["Video"] = "video";
    UploadMimeType["Icon"] = "icon";
    UploadMimeType["Logo"] = "logo";
})(UploadMimeType || (exports.UploadMimeType = UploadMimeType = {}));
exports.ASSET_MIME_TYPES = {
    text: [],
    image: ['image/png', 'image/jpeg'],
    video: [
        'video/mp4',
        'video/mkv',
        'video/avi',
        'video/flv',
        'video/wmv',
        'video/mov',
        'video/quicktime',
        'video/webm',
    ],
    icon: ['image/png', 'image/jpeg', 'image/svg+xml'],
    logo: ['image/png', 'image/jpeg', 'image/svg+xml'],
};
//# sourceMappingURL=uploader.types.js.map